import { auth } from '../firebaseConfig'; // Import auth to get user info
import { callApi } from './apiService';

/**
 * Registra uma atividade do usuário no log.
 * @param {string} activityType - O tipo de atividade (ex: 'create', 'update', 'delete', 'view').
 * @param {string} target - A entidade que foi afetada (ex: 'project', 'task').
 * @param {string} targetId - O ID do documento afetado.
 * @param {object} details - Detalhes adicionais da atividade.
 * @param {string} identifier - Um identificador amigável para o alvo.
 */
export const logActivity = async (activityType, target, targetId, details, identifier) => {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) {
        console.warn("Nenhum usuário autenticado para registrar atividade.");
        return;
    }

    const payload = {
      activityType,
      target,
      targetId,
      details,
      identifier,
      // Pass user info for the local server, as it doesn't have context.auth
      userId: currentUser.uid,
      userEmail: currentUser.email,
      userName: currentUser.displayName || currentUser.email,
    };

    // Use callApi which handles authentication headers
    await callApi('logActivity', payload);
  } catch (error) {
    console.error("Erro ao registrar atividade:", error);
  }
};

/**
 * Busca o log de atividades de uma entidade específica.
 * @param {string} target - A entidade que foi afetada (ex: 'pendency').
 * @param {string} targetId - O ID do documento afetado.
 * @returns {Promise<Array>} Uma lista de atividades.
 */
export const getActivityLog = async (target, targetId) => {
    try {
        const payload = { target, targetId };
        // callApi returns the response body directly
        return await callApi('getActivityLog', payload);
    } catch (error) {
        console.error("Erro ao buscar o log de atividades:", error);
        return [];
    }
};

/**
 * Busca todos os logs de atividade com paginação e filtros.
 * @param {number} page - O número da página a ser buscada.
 * @param {string} searchQuery - O termo de busca para o email do usuário.
 * @param {string} startDate - A data de início para o filtro (ISO string).
 * @param {string} endDate - A data de fim para o filtro (ISO string).
 * @param {boolean} exporting - Flag para indicar se é uma exportação de dados.
 * @returns {Promise<{logs: Array, total: number}>} Um objeto com a lista de logs e o número total de registros.
 */
export const getAllActivityLogs = async (page, searchQuery, startDate, endDate, exporting = false) => {
    try {
        const payload = { page, searchQuery, startDate, endDate, exporting };
        // callApi returns the response body directly
        return await callApi('getAllActivityLogs', payload);
    } catch (error) {
        console.error("Erro ao buscar todos os logs de atividade:", error);
        return { logs: [], total: 0 };
    }
};
